"use client"
import React, { useRef, useContext, useEffect, useState } from "react"
// import { createPortal } from "react-dom"
import styles from "./Modal.module.scss"

//context
import { ModalContext } from "@/contexts/ModalProvider"

async function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

function Modal({ children }) {
  const { openModal, setOpenModal } = useContext(ModalContext)
  const [isVisible, setIsVisible] = useState(false)
  const modalRef = useRef()

  const closeModal = (e) => {
    if (modalRef.current === e.target) {
      setOpenModal(false)
    }
  }

  useEffect(() => {
    if (openModal) {
      setIsVisible(true)
    } else {
      sleep(1000).then(() => {
        setIsVisible(false)
      })
    }
  }, [openModal])
  //   return createPortal(
  return (
    <div className={`${styles.modal} ${openModal ? styles.opened : ""}`}>
      <div
        ref={modalRef}
        className={styles.modal__wrap}
        onClick={(e) => closeModal(e)}
      >
        {isVisible ? children : <></>}
      </div>
    </div>
  )
}

export default Modal
